/* eslint-disable react-hooks/exhaustive-deps */
import React, { lazy, useState, useEffect, useRef, Suspense, useMemo, useCallback } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { ProjectService } from "../../service/PegaService";
import ArtworkStatusListHeader from "./ArtworkStatusListHeader";
import { getArtworkStatusList, savePmpStatusComments } from "../../apis/artworkStatusApi";
// import { getArtworkStatusList } from "../../store/actions/ArtworkStatusActions";
import { multiFilterChange, checkIfObjectOrderSame, bufferToWork } from "../../utils";
import _, { isEmpty } from "lodash";
import ArtworkStatusProjectNameHeader from "./ArtworkStatusProjectNameHeader";
import { cicImage, artworkStatusExportCSVFlags, getStatusFlags } from "./utils";
import { getProjectValues, SpecialProjectAction } from "../../store/actions/ProjectSetupActions";
import AlertIcon from "../common/AlertIcon/AlertIcon";
import { dsbpConstant } from "../DSBP/constant";
import { checkIfGreyIcon, checkIfRedIcon } from "../DSBP/utils";
import Footer from "../common/tableFooter/tableFooter";
import { isString } from "lodash";
import CustomInput from "../common/CustomInput";
import {
  hallowGreyCircle,
  hallowRedCircle,
  inProgressLate,
  redCross,
  greenV,
  hallowGreenCircle,
  solidGreenCircle,
  UnallocatedHallowGreyCircle,
  UnallocatedSolidGreenCircle,
  UnallocatedNA,
  NA,
} from "./constant";
import { formatDate } from "../Projects/ProjectPlan/util";
import ACPFilter from "../ACP/common/ACPFilter";
import { AcpService } from "../../service/ACPService";
import { AcpCommonService } from "../../service/AcpCommonService";
import { getColumnsOrder, setColumnsOrder } from "../../apis/commonApi";
import { isRoleMatch } from "../../utils";
import UnAuthorizedComponent from "../UnAuthorized/UnAuthorizedComponent";
import { localWidthStorage } from "../../utils";
import { formCustomizeObject } from "../../utils";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../common/NavigationPrompt";
import { Button } from "react-bootstrap";
import "./index.scss"
import { CharacterLimit } from "../common/CharacterLimit/CharacterLimit";
import * as types from "../../store/types/types";

const FullKitConditionPopUp = lazy(() => import("./FullKitConditionPopUp"));

const ArtworkStatusList = (props) => {
  const colAllSelected = useRef([]);
  const selectedFieldsRef = useRef([]);
  const [pegadata, setPegaData] = useState(null);
  const [isCICAddded, setIsCICAddded] = useState(false);
  const [isSpecialProject, setIsSpecialProject] = useState(false);
  const [initpegadata, setInitPegaData] = useState(null);
  const [ProjectFrozen, setProjectFrozen] = useState(false);
  const [frozenCoulmns, setFrozenColumn] = useState([]);
  const [selectedColumnName, setSelectedColumnName] = useState(null);
  const [projectColumnName, setProjectColumnNames] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filteredDataExport, setFilteredDataExport] = useState([]);
  const [visible, setVisible] = useState(false);
  const [sortData, setSortData] = useState([]);
  const [allColumnNamesArtworkStatus, setAllColumnNames] = useState([]);
  const [updatedAllColumnNames, setUpdatedAllColumnNames] = useState([]);
  const [isReorderedColumn, setReorderedColumn] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isColWidthSet, setColWidth] = useState(null);
  const [customViewIsAddedMyProject, isCustomViewIsAddedArtworkStatus] = useState(false);
  const [openFullKitpopUp, setOpenFullkitPopUp] = useState(false);
  const [filterCleared, setFilterCleared] = useState(false);
  const [rowFullkitData, setRowFullkitData] = useState(null);
  const [fieldName, setFieldName] = useState(null);
  const [pmpList, setPMPList] = useState([]);
  const [artworkStatus, artworkStatusList] = useState([]);
  const [tableRender, setTableRender] = useState(false);
  const [initialColumnLength, setinitialColumnLength] = useState({});
  const [customizeViewFields, setCustomizeViewFields] = useState([]);
  const [resizeMode, setResizeMode] = useState("fit");
  const [conditionMatched, setConditionMatched] = useState(false);
  const [datatableColumnFromPega, setDatatableColumnFromPega] = useState([]);
  const [bu, setBu] = useState("");
  const [region, setRegion] = useState("");
  const [checkReadWriteAccess, setUserAccess] = useState(false);
  const [accessType, setAccessType] = useState(null);
  const [pmpStatusComments, setPmpStatusComments] = useState({});
  const [isFlowLeader, setIsFlowLeader] = useState(false);
  const [resetCustomInputs, setResetCustomInputs] = useState(false);
  const [editingInProgress, setEditingInProgress] = useState(false);
  const [pageEdited, setPageEdited] = useState(false);
  const { markDirty, markClean } = useUnsavedChangesWarning();
    const [pgDefaultColumns,setPgDefaultColumns]=useState({})
   const [ArtworkWrapFreeText, setArtworkWrapFreeText] = useState(() => {
      const saved = sessionStorage.getItem("ArtworkWrapFreeText");
      return saved === "true";
    });

    useEffect(() => {
      sessionStorage.setItem("ArtworkWrapFreeText", ArtworkWrapFreeText);
    }, [ArtworkWrapFreeText]);

  const headerName = "Artwork Status";

  const { loading } = false;
  let { ProjectID } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterArray = useRef([]);
  const selectedColumnList = useRef([]);
  const currentUrl = useLocation().pathname.split("/");
  const {
    userDetails: { UserGroup , AccessGroup},
  } = useSelector((state) => state?.UserDetailsReducer);
  const { userInformation } = useSelector((state) => state.UserReducer);
  const isSearch = useSelector((state) => state?.SearchFilterReducer?.artworkStatus);

  let isCIC = isCICAddded;

  const onSearchClick = useCallback(() => {
    dispatch({ type: types.ALTER_SEARCH_FILTER, page: "artworkStatus" });
    setResetKey((prev)=> prev + 1);
  }, [isSearch]);

  const op = useRef(null);
  const dt = useRef(null);

  const onSort = (column, direction, filterData) => {
    let sortedData;
    if(filterData !== "globalClearFilter"){
      sortedData = filterData?.length ? filterData : filters?.length ? filters : pegadata;
    }
    else{
      sortedData = pegadata;
    }
    const sortedDataSet = AcpService.sortDataFirstStringThenNumeric(sortedData, column, direction);
    const finalSortedData = _.cloneDeep(sortedDataSet);

    setSortData([column, direction]);
    localStorage.setItem("sortingDataArtworkStatus", JSON.stringify(true));
    if (filterData !== "globalClearFilter" && (filterData?.length || filters?.length)) {
      setFilters(finalSortedData);
      selectedColumnList.current = finalSortedData;
    } else {
      setPegaData(finalSortedData);
    }
    setFilteredDataExport(finalSortedData);
  };

  useEffect(()=>{
    
    let selectedFieldsNames=projectColumnName.map(item=>item.Field_Name)
    const pgDefaultColumns=formCustomizeObject([],[],selectedFieldsNames)
    setPgDefaultColumns(pgDefaultColumns);    
    setSelectedColumnName("");
  },[pegadata,projectColumnName]);
  useEffect(() => {
    const isUserAccess = isRoleMatch(AccessGroup, [
      "CapacityManager",
      "ProjectManager",
      "TaskOwner",
    ]);
    setUserAccess(isUserAccess);
    
    // Check if user is Flow Leader for PMP Status Comment editing
    const isFlowLeaderAccess = isRoleMatch(AccessGroup, ["ProjectManager"]);
    setIsFlowLeader(isFlowLeaderAccess);
    
    setLoader(false);
  }, [AccessGroup]);

  useEffect(()=>{
    if(accessType==="Hidden"){
      setUserAccess(false)
    }else if(accessType === "Read"){
      setUserAccess(true);
    }else if(accessType === "Write"){
      setUserAccess(true);
    }
  },[accessType])
  useEffect(() => {
    //Added payload for url access for issue 3109
    if (checkReadWriteAccess && userInformation?.userid && UserGroup && ProjectID) {
      const userAccessPayLoad = {
        ArtworkAgilityPage: {
          UserId: userInformation?.userid,
          ProjectID: ProjectID,
          UserGroup: UserGroup
        }
      };
      dispatch(getProjectValues(ProjectID, userAccessPayLoad));
    }
    const columnNamesInitial = ProjectService.getAllColumnNames();
    setinitialColumnLength({
      availableFields: 0,
      freezedColumns: 0,
      selectedFields: columnNamesInitial.length,
    });
  }, [checkReadWriteAccess, ProjectID, userInformation?.userid, UserGroup]);

  // Clear PMP Status Comments state on component mount to ensure fresh start
  useEffect(() => {
    clearPmpStatusComments();
  }, []);

  const convertData = useCallback((data) => { 
    return (data || [])?.map((el) => {
      return {
        ...el,
        Req: el?.Req ? el?.Req : el?.AWPrinterDate,
        ETA: el?.ETA ? el?.ETA : el?.POAReleaseDate,
      };
    });
  }, []);

  const fetchData = async () => {
      setLoader(true);
      try {
        // Validate required data before making API call
        if (!userInformation?.userid || !UserGroup || !ProjectID) {
          // Missing required data for API call
          setLoader(false);
          return;
        }

        const userAccessPayLoad = {
          ArtworkAgilityPage: {
            UserId: userInformation?.userid,
            ProjectID: ProjectID,
            UserGroup: UserGroup
          }
        };
        const updatedUsers = await getArtworkStatusList(ProjectID, userAccessPayLoad);
        setAccessType(updatedUsers?.AccessType)
        dispatch(SpecialProjectAction(updatedUsers?.SpecialProject));
        const pmpList = updatedUsers?.PMPList || [];
        //3518 - unallocated we should always show cic column even if cic is false
        if(updatedUsers?.SpecialProject === "Yes"){
          setIsCICAddded(true);
        } else {
          setIsCICAddded(updatedUsers?.CICs);
        }
        setIsSpecialProject(updatedUsers?.SpecialProject === "Yes");
        artworkStatusList(updatedUsers);
        
        const updatedData = convertData(pmpList).sort((a, b) => {
          const aNum = parseFloat(a?.BufferToWorkRatio);
          const bNum = parseFloat(b?.BufferToWorkRatio);
          return (
            (Number.isFinite(aNum) ? aNum : Infinity) - (Number.isFinite(bNum) ? bNum : Infinity)
          );
        });
        
        setInitPegaData(_.cloneDeep(updatedData));
        setFilteredDataExport(updatedData);
        setPegaData(updatedData);
        setPMPList(updatedData);
        setBu(updatedUsers?.BU);
        setRegion(updatedUsers?.Region);
      } catch (error) {
        // Error handling without console logging
        // Show user-friendly error message
        alert('Failed to load artwork status data. Please check your network connection and try again.');
      } finally {
        setLoader(false);
      }
    };

  useEffect(() => {
    // Only call fetchData when we have all required data and user has access
    if (checkReadWriteAccess && userInformation?.userid && UserGroup && ProjectID) {
      fetchData();
    } else if (checkReadWriteAccess) {
      // Set loader to false if we have access but missing required data
      setLoader(false);
    }
  }, [ProjectID, checkReadWriteAccess, userInformation?.userid, UserGroup]);
  useEffect(() => {
    const ProjectData = _.cloneDeep(pmpList);
    let allCol = [];
    if (ProjectData.length) {
      allCol = Object.keys(ProjectData[0]);
    }
    if (!isCIC) {
      allCol = allCol.filter((item) => item !== "CIC");
    }
    if (isCIC && !allCol.includes("CIC")) allCol.splice(10, 0, "CIC");

    let columnWidthArtworkStatus = {
      PIMaterialDescription: 200,
      POADescription: 200,
    };

    // if (allCol.length) {
    //   allCol.forEach((column) => {
    //     columnWidthArtworkStatus[column] = 200;
    //   });
    // }

    let getJsonStoredWidthColumns = localStorage.getItem("columnWidthArtworkStatus");
    let getStoredWidthColumns = JSON.parse(getJsonStoredWidthColumns);
    const checkEmptyObject = _.isEmpty(getStoredWidthColumns);

    if (checkEmptyObject) {
      if (!isCIC) {
        getStoredWidthColumns = getStoredWidthColumns?.filter((item) => item !== "CIC");
      }
      if (isCIC && !getStoredWidthColumns?.includes("CIC"))
        getStoredWidthColumns?.splice(10, 0, "CIC");

      localStorage.setItem("columnWidthArtworkStatus", JSON.stringify(columnWidthArtworkStatus));
    }
    let jsonColWidth = localStorage.getItem("isColWidthSetArtworkStatus");
    let isColWidthSetFlag = JSON.parse(jsonColWidth);
    if (isColWidthSetFlag) {
      setColWidth(true);
    }
  }, [pmpList]);

  const reorderColumns = useCallback((columns) => {
    const requiredColumnOrderArray = ProjectService.getAllColumnNames();
    let reorderedColumns = [];
    requiredColumnOrderArray.forEach((rcl) => {
      columns.forEach((cl) => {
        if (rcl.Field_Name === cl) {
          reorderedColumns.push(cl);
        }
      });
    });
    
    // Ensure PMP Status Comment is added if it's in the columns but not in reorderedColumns
    if (columns.includes("AWM_PMPStatusComment") && !reorderedColumns.includes("AWM_PMPStatusComment")) {
      reorderedColumns.push("AWM_PMPStatusComment");
    }
    
    return reorderedColumns;
  }, []);

  useEffect(() => {
    setCustomizeViewFields(customizeViewFields);
  }, [customizeViewFields]);

  useEffect(()=>{
    const fetchColumnFromPega  = async () => {
      setLoader(true);
      try {
        if (bu != null && region != null && bu !== "" && region !== "") {
          const datatableColumnFromPegaRes = await getColumnsOrder(userInformation?.userid, "allColumnNamesArtworkStatus", bu, region);
          if (datatableColumnFromPegaRes != null && datatableColumnFromPegaRes?.length > 0) {
            setAllColumnNames(datatableColumnFromPegaRes);
            setDatatableColumnFromPega(datatableColumnFromPegaRes);
          }
          else {
            let localAllColumns = localStorage.getItem("allColumnNamesArtworkStatus");
            let _allColumns = JSON.parse(localAllColumns);
            if (isEmpty(_allColumns)) {
              _allColumns = ProjectService.getAllColumnNames();
            }
            setAllColumnNames(_allColumns)
          }
          const customizeViewArtworkStatusFieldsFromPega = await getColumnsOrder(userInformation?.userid, "customizeViewArtworkStatusFields", bu, region);
          if(customizeViewArtworkStatusFieldsFromPega != null && customizeViewArtworkStatusFieldsFromPega!==""){
            costomizeFrozenData();
            setCustomizeViewFields(JSON.stringify(customizeViewArtworkStatusFieldsFromPega));
          }
        }
      } catch (error) {
        // Error handling without console logging
      }
      setLoader(false);
    };

    fetchColumnFromPega();
  },[bu,region]);


  useEffect(() => {
    (async () => {
      try {
        //below is api call
        const ProjectData = _.cloneDeep(pmpList);

        if (ProjectData.length) {
          let allCol = Object.keys(ProjectData[0]);
          
          if (!isCIC) {
            allCol = allCol.filter((item) => item !== "CIC");
          }
          if (isCIC && !allCol.includes("CIC")) allCol.splice(10, 0, "CIC");

          if (!allCol.includes("Design")) allCol.splice(9, 0, "Design");

          if (!allCol.includes("FA")) allCol.splice(12, 0, "FA");

          // Add PMP Status Comment column if not present
          if (!allCol.includes("AWM_PMPStatusComment")) {
            allCol.push("AWM_PMPStatusComment");
          }

          if(isEmpty(datatableColumnFromPega) || !datatableColumnFromPega) 
            setAllColumnNames(reorderColumns(allCol));
        }

        let filteredPegaDataJson = localStorage.getItem("columnWiseFilterDataArtworkStatus");
        const filteredPegaData = JSON.parse(filteredPegaDataJson);

        if (filteredPegaData && filteredPegaData.length) {
          setFilters(filteredPegaData);
          setFilteredDataExport(filteredPegaData);
          // setSelectedFields(filteredPegaData);
          // setPegaData(ProjectData);
          // setInitPegaData(ProjectData);
        }
        // else setPegaData(ProjectData);

        // according to pathname we need to call api and store column name in local storage
        let columnNamesJson = localStorage.getItem("allColumnNamesArtworkStatus");
        const columnNames = JSON.parse(columnNamesJson);
        const fieldToAdd = { Field_Name: "CIC" };
        const pmpFieldToAdd = { Field_Name: "AWM_PMPStatusComment" };
        
        if (columnNames != null && columnNames.length) {
          
          if (isCIC && !columnNames.some((item) => item.Field_Name === fieldToAdd.Field_Name)) {
            columnNames.splice(18, 0, fieldToAdd);
          }
          
          // Ensure PMP Status Comment is added to existing column names
          if (!columnNames.some((item) => item.Field_Name === pmpFieldToAdd.Field_Name)) {
            columnNames.push(pmpFieldToAdd);
            // Update localStorage with the new column
            localStorage.setItem("allColumnNamesArtworkStatus", JSON.stringify(columnNames));
          }
          
          setProjectColumnNames(columnNames);
          setUpdatedAllColumnNames(columnNames);
        } else {
          let columnNames = ProjectService.getAllColumnNames();
          
          if (!isCIC) {
            columnNames = columnNames.filter((item) => item.Field_Name !== "CIC");
          }
          if (isCIC && !columnNames.some((item) => item.Field_Name === fieldToAdd.Field_Name)) {
            columnNames.splice(15, 0, fieldToAdd);
          }

          localStorage.setItem("allColumnNamesArtworkStatus", JSON.stringify(columnNames));
          setProjectColumnNames(columnNames);
          setUpdatedAllColumnNames(columnNames);
        }
        // get sort data from local storage and add in state
        let jsonSortingData1 = localStorage.getItem("sortingDataArtworkStatus");
        const sortingDataArtworkStatus = JSON.parse(jsonSortingData1);

        if (sortingDataArtworkStatus && sortingDataArtworkStatus.length) {
          const sortedData = [...ProjectData].sort((a, b) => {
            return a[sortingDataArtworkStatus[0]] > b[sortingDataArtworkStatus[0]] ? 1 : -1;
          });

          if (sortingDataArtworkStatus[1] === "desc") {
            sortedData.reverse();
          }
          const updatedData = convertData(sortedData);
          setPegaData(updatedData);
          setSortData([sortingDataArtworkStatus[0], sortingDataArtworkStatus[1]]);
        }

        //get frozen data from local storage and add in state
        // let jsonFrozenrData1 = localStorage.getItem("frozenDataArtworkStatus");
        // const frozenDataArtworkStatus = JSON.parse(jsonFrozenrData1);
        // if (frozenDataArtworkStatus && frozenDataArtworkStatus.length) {
        //   setFrozenColumn(frozenDataArtworkStatus);
        // }
      } catch (err) {
        // Error handling without console logging
      }
    })();
  }, [pmpList]);

  
  useEffect(() => {
    const parsedData =
      customizeViewFields !== "" && customizeViewFields?.length !== 0
        ? JSON.parse(customizeViewFields)
        : [];

    const selectedData = parsedData?.selectedFields?.fieldsData || [];
    const frozenData = parsedData?.freezedColumns?.fieldsData || [];
    const totalColumns = [...selectedData, ...frozenData];
    let columnNamesJson = localStorage.getItem("allColumnNamesArtworkStatus");
    const allColumnNames = JSON.parse(columnNamesJson);
    const finalTotalColumns=totalColumns?.length>0?totalColumns:allColumnNames // if customizeviewfeilds are empty take it from localstorage AWM-3153
    if (finalTotalColumns?.length < 7) {
      setResizeMode("fit");
    } else {
      setResizeMode("expand");
    }
  }, [customizeViewFields]);

  const formatFilterData = useCallback((data) => {
    const formattedData = {
      ...data,
    };
    formattedData["DSBP InitiativeID"] = data?.DSBP_InitiativeID;
    formattedData["DSBP Initiative Name"] = data?.DSBP_Initiative_Name;
    formattedData["RTA ProjectID"] = data?.RTA_ProjectID;
    formattedData["RTA Project Name"] = data?.RTA_Project_Name;
    formattedData["B|W"] = data?.BufferToWork;
    formattedData["B:W"] = data?.BufferToWorkRatio;
    formattedData["CIC"] = data?.CICFlag;
    formattedData["FA"] = data?.FAFlag;
    formattedData["Country Of Sales"] = data?.CountryOfSales;
    formattedData["FA Approval (A/A/R)"] = data?.FAApproval;
    formattedData["Design"] = data?.DesignFlag;
    formattedData["Assemble FA Status"] = data?.FAAssemblyState;
    formattedData["FAAssemblyEndDate"] = !isString(data?.FAAssemblyEndDate)
      ? formatDate(data?.FAAssemblyEndDate)
      : data?.DispatchFAToPrinterEndDate;  
    formattedData["FAApprovalEndDate"] = !isString(data?.FAApprovalEndDate)
      ? formatDate(data?.FAApprovalEndDate)
      : data?.FAApprovalEndDate;    
    formattedData["Group"] = data?.AWM_GroupPMP;
    formattedData["PMP State"] = data?.PMPState;
    formattedData["POA Description"] = data?.POADescription;
    formattedData["POA Number"] = data?.POANumber;
    formattedData["POA Status"] = data?.POAStatus;
    formattedData["TD State"] = data?.TDState;
    formattedData["Copy"] = data?.ApprovedCopyElements + "/" + data?.TotalCopyElements;
    formattedData["ETA"] = !isString(data?.POAReleaseDate)
      ? formatDate(data?.POAReleaseDate)
      : data?.POAReleaseDate;
    formattedData["Req"] = !isString(data?.AWPrinterDate)
      ? formatDate(data?.AWPrinterDate)
      : data?.AWPrinterDate;
    formattedData["Project ID"] = data?.ProjectID;
    formattedData["CIC Approval Status"] = data?.CICApprovalStatus;
    formattedData["Rework"] = data?.Rework;
    formattedData["Supporting PMP"] = data?.SupportingPMP;
    formattedData["CIC Needed Flag"] = data?.CICNeededFlag;
    formattedData["RDT"] = data?.RDTStatus;
    formattedData["CD/PT"] = data?.NPFStatus;
    formattedData["Ink Qual"] = data?.IQStatus;
    formattedData["Estimated AW Printer"] = !isString(data?.Estimated_AW_Printer)
      ? formatDate(data?.Estimated_AW_Printer)
      : data?.Estimated_AW_Printer;
    formattedData["POATOBVEStatus"] = data?.POATOBVEStatus;  
    formattedData["POATOBVEEndDate"] = !isString(data?.POATOBVEEndDate)
      ? formatDate(data?.POATOBVEEndDate)
      : data?.POATOBVEEndDate;
    formattedData["DispatchFAToPrinterStatus"] = data?.DispatchFAToPrinterStatus;  
    formattedData["DispatchFAToPrinterEndDate"] = !isString(data?.DispatchFAToPrinterEndDate)
      ? formatDate(data?.DispatchFAToPrinterEndDate)
      : data?.DispatchFAToPrinterEndDate;  
    return formattedData;
  }, []);

  const addFrozenColumns = useCallback((name) => {
    if (!frozenCoulmns.includes(name)) {
      frozenCoulmns.push(name);
      setFrozenColumn(frozenCoulmns);
    } else {
      let columnIndex = frozenCoulmns.indexOf(name);
      frozenCoulmns.splice(columnIndex, 1);
      setFrozenColumn(frozenCoulmns);
    }
  }, [frozenCoulmns]);

  const projectNameOnClick = useCallback((e, options) => {
    setFilterCleared(false);
    op.current.toggle(e);
    setSelectedColumnName(options);
  }, []);

  const StatusFlags = ({ state }) => {
    const { statusFlags, text } = getStatusFlags({ state }); // Pass state as an object
    return (
      <div>
        <span
          className={statusFlags}
          style={{
            padding: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "8rem",
            fontSize: "1rem",
            textAlign: "center",
            borderRadius: "4px",
          }}
        >
          {text}
        </span>
      </div>
    );
  };

  // Handle PMP Status Comment updates
  const handlePmpCommentChange = useCallback((options, e, field) => {
    const projectId = options.PIMaterialID || options.ProjectID || options.Project_ID || 
                     options.DSBP_InitiativeID || options.PIMaterialNumber;
    
    if (projectId) {
      const newValue = e.target.value;
      const originalValue = options.AWM_PMPStatusComment || '';
      
      setPmpStatusComments(prev => {
        const updated = { ...prev };
        
        // If value changed from original, track it. If reverted to original, remove it.
        if (newValue !== originalValue) {
          updated[projectId] = newValue;
        } else {
          delete updated[projectId];
        }
        
        return updated;
      });
      
      // Mark page as edited and dirty for navigation warning
      setPageEdited(true);
      markDirty();
    }
  }, [markDirty]);

  // Render PMP Status Comment input field
  const renderPmpStatusComment = useCallback((options) => { 
    const projectId = options.PIMaterialID || options.ProjectID || options.Project_ID || 
                     options.DSBP_InitiativeID || options.PIMaterialNumber;
    
    // Check state first, then fall back to row data
    const currentValue = pmpStatusComments[projectId] !== undefined 
      ? pmpStatusComments[projectId] 
      : (options.AWM_PMPStatusComment || '');
    
    return (
      <>
        <CustomInput
          type="text"
          field={"AWM_PMPStatusComment"}
          maxLength={256}
          options={options}
          sortData={sortData}
          value={currentValue}
          fieldType="AWM_PMPStatusComment"
          onChange={handlePmpCommentChange}
          filterData={selectedFieldsRef?.current}
          placeholder={"Enter PMP status comment..."}
          disabled={!isFlowLeader}
          resetCustomInputs={resetCustomInputs}
          setResetCustomInputs={setResetCustomInputs}
          setEditingInProgress={setEditingInProgress}
        />
        <CharacterLimit field={currentValue} maxLength={256} />
      </>
    );
  }, [pmpStatusComments, sortData, handlePmpCommentChange, isFlowLeader, resetCustomInputs]);

  const fullKitReadinessBody = useCallback((options, rowData) => {
    let field = rowData.field;

    const showRedIcon = options.ChangeHandlingIcon === "Red";
    const showGreyIcon = options.ChangeHandlingIcon === "Grey" || options.ChangeHandlingIcon === "Gray"; // Handle both spellings
    const showAlertIcon = showRedIcon || showGreyIcon;
    
    return (
      <>
        {/* {field === 'SI.No' && <span title={rowData.rowIndex + 1}>{rowData.rowIndex + 1}</span>} */}
        {field === "FAAssemblyState" && <StatusFlags state={options.FAAssemblyState} />}
        {field === "FAAssemblyEndDate" && <span title={options[field]}>{options["FAAssemblyEndDate"]}</span>}
        {field === "FAApprovalEndDate" && <span title={options[field]}>{options["FAApprovalEndDate"]}</span>}
        {field === "FAApproval" && <span>{options.FAApproval}</span>}
        {field === "CountryOfSales" && (
          <span title={options.CountryOfSales}>{options.CountryOfSales}</span>
        )}
        {field === "ApprovedCopyElements" && (
          <span title={options.ApprovedCopyElements + "/" + options.TotalCopyElements}>
            {options.ApprovedCopyElements + "/" + options.TotalCopyElements}
          </span>
        )}
        {/* {field === "POAReleaseDate" && <span title={options[field]}>{options[field]}</span>}
        {field === "AWPrinterDate" && <span title={options[field]}>{options[field]}</span>} */}

        {field === "ETA" && <span title={options[field]}>{options["ETA"]}</span>}
        {field === "Req" && <span title={options[field]}>{options["Req"]}</span>}
        {field === "Estimated_AW_Printer" && <span title={options[field]}>{options["Estimated_AW_Printer"]}</span>}
        {field === "POATOBVEStatus" && <span title={options[field]}>{options["POATOBVEStatus"]}</span>}
        {field === "POATOBVEEndDate" && <span title={options[field]}>{options["POATOBVEEndDate"]}</span>}
        {field === "DispatchFAToPrinterStatus" && <span title={options[field]}>{options["DispatchFAToPrinterStatus"]}</span>}
        {field === "DispatchFAToPrinterEndDate" && <span title={options[field]}>{options["DispatchFAToPrinterEndDate"]}</span>}
        {field === "BufferToWorkRatio" && bufferToWork(options[field])}

        {field === "FA" && (
          <div
            className="cic-tooltip-target"
            title={artworkStatusExportCSVFlags(options["FAFlag"], isSpecialProject)}
          >
            {options["FAFlag"] === "NA" ? (
              <div>{options["FAFlag"]}</div>
            ) : options["FAFlag"]?.includes("|") ? (
              <>
                <div
                  className={isSpecialProject === true ? "hide-popup" : "show-popup"}
                  onClick={() => {
                    setOpenFullkitPopUp(true);
                    setRowFullkitData(options);
                    setFieldName("fa");
                  }}
                >
                  {options["FAFlag"]}
                </div>
              </>
            ) : (
              <div
                className={isSpecialProject === true ? "hide-popup" : "show-popup"}
                onClick={() => {
                  setOpenFullkitPopUp(true);
                  setRowFullkitData(options);
                  setFieldName("fa");
                }}
              >
                <div
                  onClick={() => {
                    if (options["FAFlag"] === "GreenV") {
                      navigate(`/${currentUrl[1]}/projectPlan/${ProjectID}`);
                    } else {
                      setOpenFullkitPopUp(true);
                      setRowFullkitData(options);
                      setFieldName("fa");
                    }
                  }}
                >
                  <div className="footerIconsMain">
                    <div>
                      <i className={`footerIconAll ${cicImage(options["FAFlag"])}`}></i>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {field === "Design" && (
          <div
            className="cic-tooltip-target"
            title={artworkStatusExportCSVFlags(options["DesignFlag"], isSpecialProject)}
          >
            {options["DesignFlag"] === "NA" ? (
              <div>{options["DesignFlag"]}</div>
            ) : (
              <div className="footerIconsMain">
                <div>
                  <i className={`${cicImage(options["DesignFlag"])}`}></i>
                </div>
              </div>
            )}
          </div>
        )}

        {field === "CIC" && (
          <div className="cic-img">
            <div
              className="cic-tooltip-target"
              title={artworkStatusExportCSVFlags(options["CICFlag"], isSpecialProject)}
            >
              {options["CICFlag"] === "NA" || options["CICFlag"] === "" || !options["CICFlag"] ? (
                <div>{options["CICFlag"]}</div>
              ) : options["CICFlag"]?.includes("|") ? (
                <>
                  <div
                    className={isSpecialProject === true ? "hide-popup" : "show-popup"}
                    onClick={() => {
                      setOpenFullkitPopUp(true);
                      setRowFullkitData(options);
                      setFieldName("cic");
                    }}
                  >
                    {options["CICFlag"]}
                  </div>
                </>
              ) : (
                <>
                  <div
                    className={isSpecialProject === true ? "hide-popup" : "show-popup"}
                    onClick={() => {
                      setOpenFullkitPopUp(true);
                      setRowFullkitData(options);
                      setFieldName("cic");
                    }}
                  >
                    <div className="footerIconsMain">
                      <div>
                        <i className={`${cicImage(options["CICFlag"])}`}></i>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {field === "PIMaterialNumber" && (
          <>
            <div className="snapshot-icons" disabled={props?.userHasAccess}>
              <span title={options[field]} className="text-option">
                {options[field]}
              </span>
            </div>
            {showAlertIcon && (
              <AlertIcon
                iconType="error"
                showAlertIcon={showAlertIcon}
                onClick={() => {
                  const pmpId = options.PIMaterialID;
                  const currentUrlString = currentUrl.join("/");
                  const targetPath = `/${currentUrl[1]}/artworkStatus/ChangeHandling/${userInformation?.userid}/${ProjectID}`;
                  
                  navigate(targetPath, {
                    state: {
                      PIMaterialID: pmpId,
                      from: "artworkstatusPage",
                      assignee: userInformation?.userid,
                      InitiativeID: options?.DSBP_InitiativeID,
                      DSBP_PMP_PIMaterialID: pmpId,
                      previousUrl: currentUrlString // Store the current artwork status URL
                    },
                  });
                }}
                editable={showGreyIcon}
                tooltipClass="tooltip-white"
                tooltipText={
                  showGreyIcon
                    ? dsbpConstant.xml_awaiting_response_enovia
                    : dsbpConstant.xml_view_changes
                }
                tooltipPosition={"top"}
              />
            )}
          </>
        )}

        {/* {field === "POAStatus" && <span>{options.RTA_RTAPOAStatus}</span>} */}

        {field !== "Artwork_Status" &&
          field !== "ApprovedCopyElements" &&
          field !== "POAReleaseDate" &&
          field !== "CIC" &&
          field !== "AWPrinterDate" &&
          field !== "CICFlag" &&
          field !== "FAFlag" &&
          field !== "FAAssemblyState" &&
          field !== "FAAssemblyEndDate" &&
          field !== "FAApprovalEndDate" &&
          field !== "CountryOfSales" &&
          field !== "FAApproval" &&
          field !== "PIMaterialNumber" &&
          // field !== 'POAStatus' &&
          field !== "DesignFlag" &&
          field !== "Design" &&
          field !== "ETA" &&
          field !== "Req" &&
          field !== "Estimated_AW_Printer" &&
          field !== "POATOBVEStatus" &&
          field !== "POATOBVEEndDate" &&
          field !== "DispatchFAToPrinterStatus" &&
          field !== "DispatchFAToPrinterEndDate" &&
          field !== "BufferToWorkRatio" &&
          field !== "FA" &&
          field !== "AWM_PMPStatusComment" && (
            <>
              {" "}
              <span title={options[field]}>{options[field]}</span>{" "}
            </>
          )}
                  {field === "ProjectID" && (
          <span title={options.ProjectID}>{options.ProjectID}</span>
        )}
        {field === "CICApprovalStatus" && (
          <span title={options.CICApprovalStatus}>{options.CICApprovalStatus}</span>
        )}
        {field === "Rework" && (
          <span title={options.Rework}>{options.Rework}</span>
        )}
        {field === "SupportingPMP" && (
          <span title={options.SupportingPMP}>{options.SupportingPMP}</span>
        )}
        {field === "CICNeededFlag" && (
          <span title={options.CICNeededFlag}>{options.CICNeededFlag}</span>
        )}
        {field === "AWM_PMPStatusComment" && renderPmpStatusComment(options)}
      </>
    );
  }, [isSpecialProject, currentUrl, ProjectID, navigate, renderPmpStatusComment, userInformation]);

  const costomizeFrozenData = useCallback(() => {
    let jsonValue;
    if (customizeViewFields !== undefined && customizeViewFields?.length !== 0) {
      jsonValue = customizeViewFields ? JSON.parse(customizeViewFields) : null;
    }
    let freezedData;
    if (jsonValue && Object.keys(jsonValue)?.length !== 0) {
      freezedData = jsonValue?.freezedColumns?.fieldsData || [];
      freezedData && setFrozenColumn(freezedData);
      localStorage.setItem("frozenDataArtworkStatus", JSON.stringify(freezedData));
    }
    return freezedData;
  }, [customizeViewFields]);

  useEffect(() => {
    costomizeFrozenData();
    if (customizeViewFields && customizeViewFields === "[]") {
      setFrozenColumn([]);
      localStorage.setItem("frozenDataArtworkStatus", JSON.stringify({}));
    }
    const parsedData =
      customizeViewFields !== "" && customizeViewFields?.length !== 0
        ? JSON.parse(customizeViewFields)
        : [];
    let selectedData = parsedData?.selectedFields?.fieldsData;
    if (
      Object.keys(initialColumnLength).length > 0 &&
      selectedData?.length > 0 &&
      initialColumnLength?.selectedFields !== selectedData?.length
    ) {
      isCustomViewIsAddedArtworkStatus(true);
    } else {
      isCustomViewIsAddedArtworkStatus(false);
    }
  }, [customizeViewFields]);

  const dynamicColumns = useMemo(() => {
    const localColumnWidth=localStorage.getItem("columnWidthArtworkStatus");
    let columnWidth={};
    if(localColumnWidth){
      columnWidth=JSON.parse(localColumnWidth);
    }
    const columnWidthKeys=Object.keys(columnWidth);

    const uniqueArray = [...new Set(projectColumnName)];

    let jsonValue;
    if (customizeViewFields !== undefined && customizeViewFields?.length !== 0) {
      jsonValue = customizeViewFields ? JSON.parse(customizeViewFields) : null;
    }

    if (jsonValue && Object.keys(jsonValue).length !== 0) {
      let selectedData = jsonValue?.selectedFields?.fieldsData || [];
      let freezedData = jsonValue?.freezedColumns?.fieldsData || [];
      const mergedData = [...freezedData, ...selectedData];

      const filteredColumns = [];
      // Add freezedData columns in the specified order
      // freezedData && setFrozenColumn(freezedData);
      mergedData?.forEach((fieldName) => {
        const column = uniqueArray?.find((col) => col.Field_Name === fieldName);
        if (column) {
          filteredColumns.push(column);
        }
      });
      if (filteredColumns && filteredColumns.length) {
        return filteredColumns?.map((ele, i) => {
          return (
            <Column
              key={ele.Field_Name}
              field={ele.Field_Name}
              filterField={ele.Field_Name}
              header={ArtworkStatusProjectNameHeader(
                ele.Field_Name,
                frozenCoulmns,
                sortData,
                projectNameOnClick,
                selectedFields
              )}
              columnKey={ele.Field_Name || i}
              frozen={frozenCoulmns?.includes(ele.Field_Name)}
              alignFrozen="left"
              className={frozenCoulmns?.includes(ele.Field_Name) ? "font-bold frozen-width" : ""}
              filter
              showFilterMenu={false}
              filterMatchMode="contains"
              filterPlaceholder={ele.Field_Name}
              body={fullKitReadinessBody}
              style={{ 
                width:columnWidthKeys.includes(ele.Field_Name) && columnWidth && columnWidth[ele.Field_Name],
                maxWidth:columnWidthKeys.includes(ele.Field_Name) && columnWidth && columnWidth[ele.Field_Name],
                whiteSpace: ArtworkWrapFreeText ? 'normal' : 'nowrap',
                wordBreak: ArtworkWrapFreeText ? 'break-word': 'unset',
                overflow: ArtworkWrapFreeText ? 'unset' : 'hidden',
                textOverflow: ArtworkWrapFreeText ? 'unset' : 'ellipsis',
              }}
              // {... checkWidth.includes(ele.Field_Name) && }
              // style={{
              //   width: returnColumnWidth(
              //     columnWidthArtworkStatus[ele.Field_Name],
              //     ele.Field_Name,
              //     columnWidthArtworkStatus
              //   ),
              // }}
            />
          );
        });
      }
    } else {
      if (uniqueArray && uniqueArray?.length) {
        return uniqueArray?.map((ele, i) => {
          if (!isCIC && ele.Field_Name === "CIC") {
            // Skip rendering the column
            return null;
          }
          return (
            <Column
              key={ele.Field_Name}
              field={ele.Field_Name}
              filterField={ele.Field_Name}
              header={ArtworkStatusProjectNameHeader(
                ele.Field_Name,
                frozenCoulmns,
                sortData,
                projectNameOnClick,
                selectedFields
              )}
              columnKey={ele.Field_Name || i}
              frozen={frozenCoulmns?.includes(ele.Field_Name)}
              alignFrozen="left"
              className={frozenCoulmns?.includes(ele.Field_Name) ? "font-bold frozen-width" : ""}
              filter
              showFilterMenu={false}
              filterMatchMode="contains"
              filterPlaceholder={ele.Field_Name}
              body={fullKitReadinessBody}
              // {... checkWidth.includes(ele.Field_Name) && }
              // style={{
              //   width: returnColumnWidth(
              //     columnWidthArtworkStatus[ele.Field_Name],
              //     ele.Field_Name,
              //     columnWidthArtworkStatus
              //   ),
              // }}
              style={{ width:columnWidthKeys.includes(ele.Field_Name)&& columnWidth
                && columnWidth[ele.Field_Name],
                maxWidth:columnWidthKeys.includes(ele.Field_Name)&& columnWidth
                && columnWidth[ele.Field_Name],
                    whiteSpace: ArtworkWrapFreeText ? 'normal' : 'nowrap',
                    wordBreak: ArtworkWrapFreeText ? 'break-word': 'unset',
                    overflow: ArtworkWrapFreeText ? 'unset' : 'hidden',
                    textOverflow: ArtworkWrapFreeText ? 'unset' : 'ellipsis',
               }}
            />
          );
        });
      }
    }
  }, [projectColumnName, frozenCoulmns, sortData, projectNameOnClick, ArtworkWrapFreeText, selectedFields]);

  const clearFiltersResetToDefault = useCallback((param) => {
    const allColumnNamesArtworkStatus = ProjectService.getAllColumnNames();
    let columnWidthArtworkStatus = {
      PIMaterialDescription: 200,
      POADescription: 200,
    };
    setProjectColumnNames(allColumnNamesArtworkStatus);
    localStorage.setItem(
      "allColumnNamesArtworkStatus",
      JSON.stringify(allColumnNamesArtworkStatus)
    );
    localStorage.setItem("columnWiseFilterDataArtworkStatus", JSON.stringify({}));
    const costomizeFrozenData1 = costomizeFrozenData();

    if (costomizeFrozenData1 === undefined) {
      setFrozenColumn([]);
      localStorage.setItem("frozenDataArtworkStatus", JSON.stringify({}));
    }
    localStorage.setItem("sortingDataArtworkStatus", JSON.stringify({}));
    localStorage.setItem("frozenDataArtworkStatus", JSON.stringify({}));
    selectedFieldsRef.current = [];
    if(param==="globalReset"){
      localStorage.removeItem("isColWidthSetArtworkStatus");
      localStorage.setItem("columnWidthArtworkStatus", JSON.stringify(columnWidthArtworkStatus));
      setFilters([]);
      setSortData([]);
    }
    setColWidth(false);
    setSelectedFields([]);
    setReorderedColumn(false);
    setVisible(false);
    setFilterCleared(true);
    const updatedData = convertData(initpegadata);
    setFilteredDataExport(updatedData);
    setPegaData(updatedData);
    dispatch({ type: types.HIDE_SEARCH_FILTER, page: "artworkStatus" });
    setCustomizeViewFields([]);
    setFrozenColumn([]);
    setProjectFrozen(false);
    setResizeMode("expand");
    setResetKey((prev) => prev+1);
  }, [convertData, initpegadata]);

  const reorderColumnsSetColumnOrder = async(entities) => {
    const allColumnNamesArtworkStatus = localStorage.getItem("allColumnNamesArtworkStatus");
    const parsedallColumnNamesArtworkStatus= allColumnNamesArtworkStatus && JSON.parse(allColumnNamesArtworkStatus);

    const fieldMap = parsedallColumnNamesArtworkStatus.reduce((map, field) => {
      map[field.Field_Name] = field;
      return map;
    }, {});

    const orderedFields = entities?.columns?.selectedFields?.fieldsData.map(fieldName => {
      const field = fieldMap[fieldName];
      return field ? field : { "Field_Name": fieldName };  // In case there is a missing field
    });
    await setColumnsOrder(userInformation?.userid, "allColumnNamesArtworkStatus", bu, region, false, JSON.stringify(orderedFields));
    await setColumnsOrder(userInformation?.userid, "customizeViewArtworkStatusFields", bu, region, false, JSON.stringify(entities.columns));
    if (!checkIfObjectOrderSame(ProjectService.getAllColumnNames(), orderedFields)) {
      isCustomViewIsAddedArtworkStatus(true)
    } else {
      isCustomViewIsAddedArtworkStatus(false)
    }
    setResetKey((prev)=> prev+1);
  }

  const onGlobalFilterChange = useCallback((e, colName) => {
    const { value, multiplesFlag, arr } = multiFilterChange(
      e,
      colName,
      selectedColumnName,
      selectedFields,
      setSelectedFields,
      pegadata,
      filterArray,
      selectedColumnList,
      colAllSelected,
      selectedFieldsRef
    );
    const _selectedFieldsRef = (selectedFieldsRef?.current || []).map((el, i) => {
      if (Object.keys(arr)?.[0] === Object.keys(el)?.[0]) {
        return {
          ...el,
          [`${selectedColumnName}`]: arr[selectedColumnName],
        };
      } else {
        return el;
      }
    });
    if (AcpService.areAllPropertiesEmptyArrays(_selectedFieldsRef)) {
      localStorage.removeItem("_selectedFieldsRefCurrentArtworkStatus");
    }
    if (filterArray.current?.length) {
      if ((value?.length > 0 && !multiplesFlag) || colAllSelected.current?.length >= 1) {
        const _selectedFieldsRefWithoutEmptyArray =
          AcpService.removeEmptyArrays(_selectedFieldsRef);
        const _selectedFieldsRefWithUniqueObjects = AcpService.getUniqueObjects(
          _selectedFieldsRefWithoutEmptyArray
        );
        const filterData = AcpService.filterDataByfilters(
          pegadata,
          _selectedFieldsRefWithUniqueObjects,
          setConditionMatched,
          "artworkStatus"
        );

        const convertedObj = AcpCommonService.convertArrayToObject(
          _selectedFieldsRefWithoutEmptyArray
        );
        const uniqueObj = AcpCommonService.getUniqueValuesObject(convertedObj);
        setSelectedFields(uniqueObj);
        setFilteredDataExport(filterData);
        if (filterData?.length && sortData?.length) {
          onSort(sortData[0], sortData[1], filterData);
        } else {
          setFilters(filterData);
          selectedColumnList.current = filterData;
        }
      } else {
        selectedColumnList.current = [];
        selectedFieldsRef.current = [];
        setFilteredDataExport([]);
        setSelectedFields({});
        setFilters([]);
      }
    } else {
      selectedColumnList.current = [];
      selectedFieldsRef.current = [];
      setFilteredDataExport([]);
      setSelectedFields({});
      setFilters([]);
    }
  }, [selectedColumnName, selectedFields, pegadata, sortData, onSort]);
  const [resetKey, setResetKey] = useState(0);

  const handleChildClick = useCallback((isClicked) => {
    if (!isClicked) {
      clearFilter();
      if(isSearch){
        setResetKey((prev)=>prev + 1);
      }
    }
  }, [isSearch, initpegadata]);

  const onColumnResizeEnd = useCallback((event) => {
    let columnWidthArtworkStatus = {};
    localWidthStorage(event,"columnWidthArtworkStatus");
    localStorage.setItem("isColWidthSetArtworkStatus", JSON.stringify(true));
    setColWidth(true);
    setProjectColumnNames(projectColumnName);
    setVisible(false);
  }, [projectColumnName]);

  const saveSettings = useCallback(() => {
    localStorage.setItem("columnWiseFilterDataArtworkStatus", JSON.stringify(filters));
    localStorage.setItem("frozenDataArtworkStatus", JSON.stringify(frozenCoulmns));
    localStorage.setItem("sortingDataArtworkStatus", JSON.stringify(sortData));
    localStorage.setItem("allColumnNamesArtworkStatus", JSON.stringify(projectColumnName));
  }, [filters, frozenCoulmns, sortData, projectColumnName]);
  // not used currently
  // const saveAsPersonaliDefault = (selectedCategories) => {
  //   const columnNames = JSON.stringify(reorderColumns(selectedCategories));
  //   localStorage.setItem('allColumnNamesArtworkStatus', columnNames);
  //   setProjectColumnNames(reorderColumns(selectedCategories));
  //   if (selectedCategories.length > 9) {
  //     localStorage.setItem('isCustomViewIsAddedArtworkStatus', JSON.stringify(true));
  //     isCustomViewIsAddedArtworkStatus(true);
  //   }
  //   if (selectedCategories.length === 0) {
  //     isCustomViewIsAddedArtworkStatus(true);
  //   }
  //   setVisible(false);
  // };

  // const resetToPgDefault = async () => {
  //   const allColumnNamesArtworkStatus = ProjectService.getAllColumnNames();
  //   localStorage.setItem('allColumnNamesArtworkStatus', JSON.stringify({}));
  //   localStorage.setItem(
  //     'allColumnNamesArtworkStatus',
  //     JSON.stringify(allColumnNamesArtworkStatus)
  //   );
  //   localStorage.removeItem('isCustomViewIsAddedArtworkStatus');
  //   isCustomViewIsAddedArtworkStatus(true);
  //   setProjectColumnNames(allColumnNamesArtworkStatus);
  //   setVisible(false);
  //   // setTableRender(true);
  // };

  const storeReorderedColumns = useCallback((e) => {
    const dragColumnName = projectColumnName[e?.dragIndex];
    const index = projectColumnName.indexOf(dragColumnName);
    if (index > -1) {
      // only splice array when item is found
      projectColumnName.splice(index, 1); // 2nd parameter means remove one item only
      projectColumnName.splice(e?.dropIndex, 0, dragColumnName);
      setReorderedColumn(true);
    }
    localStorage.setItem("allColumnNamesArtworkStatus", JSON.stringify(projectColumnName));
    setProjectColumnNames(projectColumnName);
    // setTableRender(!tableRender);
  }, [projectColumnName]);

  const clearFilter = useCallback(() => {
    // localStorage.setItem("sortingDataArtworkStatus", JSON.stringify({}));
    selectedFieldsRef.current = [];
    setSelectedFields([]);
    // setSortData([]);
    setFilters([]);
    const updatedData = convertData(initpegadata);
    setFilteredDataExport(updatedData);
    setPegaData(updatedData);
    dispatch({ type: types.HIDE_SEARCH_FILTER, page: "artworkStatus" });
    // setTableRender(!tableRender);
    if(sortData?.length){
      onSort(sortData[0], sortData[1],"globalClearFilter");
    }
  }, [initpegadata, sortData]);

  const clearColumnWiseFilter = async() => {
    let jsonFrozenItem = localStorage.getItem("frozenDataArtworkStatus");
    const frozenItem = JSON.parse(jsonFrozenItem);
    let _selectedColumnName = selectedColumnName;

    if (frozenItem && frozenItem?.length && frozenItem.includes(_selectedColumnName)) {
      const index = frozenItem.indexOf(_selectedColumnName);
      frozenItem.splice(index, 1);
      setFrozenColumn(frozenItem);
      localStorage.setItem("frozenDataArtworkStatus", JSON.stringify(frozenItem));
    }
    if (frozenCoulmns.includes(_selectedColumnName)) {
      const index = frozenCoulmns.indexOf(_selectedColumnName);
      frozenCoulmns.splice(index, 1);
      setFrozenColumn(frozenCoulmns);
      setProjectFrozen(!ProjectFrozen);
      const availableColumnNamesData = JSON.parse(customizeViewFields)?.availableFields?.fieldsData;
      const freezedColumnsNamesData = frozenCoulmns?.filter((el) => el !== "SelectAll");
      const selectedFieldsNames = JSON.parse(
        customizeViewFields
      )?.selectedFields?.fieldsData?.filter((el) => el !== "SelectAll");
      let selectedFieldsNamesData = [...selectedFieldsNames, _selectedColumnName];
      const finalData = {
        availableFields: {
          fieldsData: availableColumnNamesData,
          id: "availableFields",
          title: "Available Fields",
        },
        freezedColumns: {
          fieldsData: freezedColumnsNamesData,
          id: "freezedColumns",
          title: "Freezed Fields",
        },
        selectedFields: {
          fieldsData: selectedFieldsNamesData,
          id: "selectedFields",
          title: "Selected Fields",
        },
      };
      setCustomizeViewFields(JSON.stringify(finalData));
      localStorage.setItem("customizeViewArtworkStatusFields", JSON.stringify(finalData));
    }
    if (sortData && sortData?.length && sortData[0] === _selectedColumnName) {
      localStorage.removeItem("sortingDataArtworkStatus");
      // props?.setClearAllFilter(true);
      setSortData([]);
    }

    const selectedFields2 = _.cloneDeep(selectedFields);
    const uniqueObj = AcpCommonService.getUniqueValuesObject(selectedFields2);
    const _selectedFields = AcpService.emptyProperty(uniqueObj, _selectedColumnName);
    const __selectedFields = AcpCommonService.removeEmptyArraysWithNoData(_selectedFields);
    selectedFieldsRef.current = __selectedFields;
    setSelectedFields(__selectedFields);
    if (AcpService.areAllPropertiesEmptyArrays(__selectedFields)) {
      localStorage.removeItem("_selectedFieldsRefCurrentArtworkStatus");
    }
    let data = [...(pegadata || [])];
    Object.keys(__selectedFields).forEach((el) => {
      if (__selectedFields[el]?.length) {
        data = data.filter((ele) => __selectedFields[el].includes(ele[el]));
      }
    });
    if (data?.length && Object.keys(__selectedFields)?.length) {
      setFilters(data);
      setFilteredDataExport(data);
    } else if (sortData?.length && sortData[0] !== _selectedColumnName) {
      selectedColumnList.current = pegadata;
      setFilters([]);
      onSort(sortData[0], sortData[1], pegadata);
    }else {
      const finalInitData = _.cloneDeep(initpegadata);
      const updatedData = convertData(finalInitData);
      selectedColumnList.current = updatedData;
      setFilteredDataExport(updatedData);
      selectedFieldsRef.current = [];
      setPegaData(updatedData);
      setSelectedFields({});
      setFilters([]);
    }
    setConditionMatched(false);
  };

  // Check if there are any comments that have been changed from their original values
  const hasCommentsToSave = useMemo(() => 
    pmpStatusComments && Object.keys(pmpStatusComments).length > 0,
    [pmpStatusComments]
  );

  const isFilterEnabled = useMemo(() => filters?.length || isSearch, [filters, isSearch]);

  const isResetEnabled = useMemo(() => 
    isFilterEnabled || frozenCoulmns?.length || customViewIsAddedMyProject,
    [isFilterEnabled, frozenCoulmns, customViewIsAddedMyProject]
  );

  const timestamp = new Date().getTime();

  const handleCancelPmpComments = useCallback(() => {
    resetPmpStatusComments();
  }, []);

  // Handle Save PMP Status Comments
  const handleSavePmpComments = async () => {
    try {
      let pmpCommentsArray = []

      for (let key in pmpStatusComments) {
        const rowData = pegadata.find((row) => key === row.PIMaterialID);

        pmpCommentsArray.push({
          DSBP_InitiativeID: rowData?.DSBP_InitiativeID || "",
          DSBP_PMP_PIMaterialID: key,
          AWM_PMPStatusComment: pmpStatusComments[key],
        });
      }

      await savePmpStatusComments(ProjectID, pmpCommentsArray);
      
      setPmpStatusComments({});
      setPageEdited(false);
      markClean();
      fetchData();  
    } catch (error) {
      console.error(error)
    }
  };

  const artworkstatusfooter = useMemo(() => (
    <div>
      <div className="footerIcons">
        {!isSpecialProject && (
          <div className="footerIconsMain footIcon">
            <div>
              <i className="pi pi-info footerIconAll footerIcons2"></i>
            </div>
            <div className="footerIconsContent1">Snapchange alert is true</div>
          </div>
        )}
        <div className="footerIconsMain footIcon">
          <div>
            <i className="pi pi-check footerIconAll footerIcons3"></i>
          </div>
          <div className="footerIconsContent1">{greenV}</div>
        </div>

        {!isSpecialProject && (
          <div className="footerIconsMain footIcon">
            <div>
              <i className="pi pi-times footerIconAll footerIcons4"></i>
            </div>
            <div className="footerIconsContent1">{redCross}</div>
          </div>
        )}

        {!isSpecialProject && (
          <div className="footerIconsMain footIcon">
            <div>
              <i className="pi pi-circle-off footerIconAll footerIcons5"></i>
            </div>
            <div className="footerIconsContent1">{hallowGreenCircle}</div>
          </div>
        )}

        {!isSpecialProject && (
          <div className="footerIconsMain footIcon">
            <div>
              <i className="pi pi-circle-off footerIconAll footerIcons6"></i>
            </div>
            <div className="footerIconsContent1">
              <span> {hallowRedCircle}</span>
            </div>
          </div>
        )}

        <div className="footerIconsMain footIcon ">
          <div>
            <i className="pi pi-circle-off footerIconAll footerIcons7"></i>
          </div>
          <div className="footerIconsContent1">
            <span>{isSpecialProject ? UnallocatedHallowGreyCircle : hallowGreyCircle}</span>
          </div>
        </div>

        <div className="footerIconsMain footIcon">
          <div>
            <i className="pi pi-circle-on footerIconAll footerIcons8"></i>
          </div>
          <div className="footerIconsContent1">
            <span style={{ paddingTop: "10px" }}>
              {isSpecialProject ? UnallocatedSolidGreenCircle : solidGreenCircle}
            </span>
          </div>
        </div>

        {!isSpecialProject && (
          <div className="footerIconsMain footIcon">
            <div>
              <i className="pi pi-circle-on footerIconAll footerIcons9"></i>
            </div>
            <div className="footerIconsContent1">
              <span>{inProgressLate}</span>
            </div>
          </div>
        )}

        <div className="footerIconsMain footIcon">
          <div className="footerIcons10 footerIconAll">
            <span>2/1/0</span>
          </div>
          <div className="footerIconsContent1">
            <span>Approvers / Approved / Rejected</span>
          </div>
        </div>

        <div className="footerIconsMain footIcon">
          <div className="footerIcons11 footerIconAll">
            <span>N/A</span>
          </div>
          <div className="footerIconsContent1">
            <span>{isSpecialProject ? UnallocatedNA : NA}</span>
          </div>
        </div>
      </div>
      <div className="recordfooter">
        {!loader && (filters?.length || pegadata?.length) && (
          <Footer
            className="footer"
            isSelected={false}
            totalObjects={(filters?.length ? filters : pegadata)?.length}
          />
        )}
        <div className="pmp-comment-buttons">
          <Button
            className="button-layout"
            variant="secondary"
            onClick={handleCancelPmpComments}
          >
            Cancel
          </Button>
          <Button
            className="button-layout"
            type="submit"
            disabled={!hasCommentsToSave}
            onClick={() => handleSavePmpComments()}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  ), [isSpecialProject, loader, filters, pegadata, hasCommentsToSave, handleCancelPmpComments, handleSavePmpComments]);  

  const resetPmpStatusComments = useCallback(() => {
    setLoader(true);
    setResetCustomInputs(true);
    setPmpStatusComments({});
    setPageEdited(false);
    markClean();
    setLoader(false);
  }, [markClean]);  

  // Clear PMP Status Comments state (for refresh/reset scenarios)
  const clearPmpStatusComments = useCallback(() => {
    setPmpStatusComments({});
  }, []);

  return (
    <div className="artworkStatus">
      {loader ? (
         <LoadingOverlay active={true} spinner text="" className="overlay-loader"/>
      ) : checkReadWriteAccess ? (
        <Suspense fallback={<LoadingOverlay active={true} spinner text=""/>}>
          {pegadata !== undefined && (
            <ArtworkStatusListHeader
              isSearch={isSearch}
              header={artworkStatus?.ProjectName}
              clearFiltersResetToDefault={clearFiltersResetToDefault}
              clearFilter={clearFilter}
              setVisible={setVisible}
              saveSettings={saveSettings}
              onSearchClick={onSearchClick}
              isFilterEnabled={isFilterEnabled}
              isResetEnabled={isResetEnabled}
              allData={conditionMatched ? [] : filters?.length ? filters : pegadata}
              headers={allColumnNamesArtworkStatus}
              filterFLag={false}
              CustomizeViewFlag={false}
              ResetToDefaultFlag={false}
              isTreeTableFlag={false}
              AWPrinterDate={artworkStatus?.AWPrinterDate}
              projectColumnName={projectColumnName}
              headerName={headerName}
              customizeViewFields={customizeViewFields}
              setCustomizeViewFields={setCustomizeViewFields}
              selected={conditionMatched ? [] : filters?.length && filters}
              onChildClick={handleChildClick}
              setTableRender={setTableRender}
              tableRender={tableRender}
              isSpecialProject={isSpecialProject}
              bu = {bu}                     //bu and region passed as props for setColumnsOrder and getColumnsOrder API in DragAndDrop component
              region = {region}
              reorderColumnsSetColumnOrder={reorderColumnsSetColumnOrder}
              pgDefaultColumns={pgDefaultColumns}
              ArtworkWrapFreeText={ArtworkWrapFreeText}
              setArtworkWrapFreeText={setArtworkWrapFreeText}
              pmpStatusComments={pmpStatusComments}
              filename={`${artworkStatus?.AWMProjectID}_${artworkStatus?.ProjectName}_Artwork Status`}
            />
          )}
          <ACPFilter
            op={op}
            onSort={onSort}
            filters={filters}
            sortData={sortData}
            projectData={pegadata}
            setFilters={setFilters}
            setSortData={setSortData}
            pageName={"artworkStatus"}
            saveSettings={saveSettings}
            ProjectFrozen={ProjectFrozen}
            frozenCoulmns={[]}
            selectedFields={selectedFields}
            selectAllColumnNotIncluded={true}
            setFrozenColumn={setFrozenColumn}
            setProjectFrozen={setProjectFrozen}
            addFrozenColumns={addFrozenColumns}
            selectedColumnName={selectedColumnName}
            onGlobalFilterChange={onGlobalFilterChange}
            clearColumnWiseFilter={clearColumnWiseFilter}
          />

          <DataTable
            ref={dt}
            rows={50}
            scrollable
            resizableColumns
            id={`${isSpecialProject && "special-project"}`} // special project flag for adjusting the height to fit pagination in the bottom
            className={`mt-3 `}
            reorderableColumns
            dataKey="PIMaterialID"
            tableStyle={{
              minWidth: "100%",
              width: "max-content",
            }}
            columnResizeMode={"expand"}
            paginatorPosition="bottom"
            footer={artworkstatusfooter}
            filterDisplay={isSearch && "row"}
            onColReorder={storeReorderedColumns}
            onColumnResizeEnd={onColumnResizeEnd}
            paginator={isSpecialProject ? pegadata?.length || filters?.length : false}
            key={
              filterCleared || tableRender
                ? `"PIMaterialID" +${resetKey}`
                : `${resetKey}`
            }
            value={conditionMatched ? [] : filters?.length ? filters : pegadata}
          >
            {dynamicColumns}
          </DataTable>
       
          
          <div hidden={filters?.length ? filters?.length === 0 : pegadata?.length === 0}>
            <FullKitConditionPopUp
              openFullKitpopUp={openFullKitpopUp}
              setOpenFullkitPopUp={setOpenFullkitPopUp}
              rowFullkitData={rowFullkitData}
              setRowFullkitData={setRowFullkitData}
              fieldName={fieldName}
              artworkStatus={artworkStatus}
            />
          </div>
        </Suspense>
      ):(
        AccessGroup && AccessGroup.length && <UnAuthorizedComponent nowrapper={true} />
      )}
    </div>
  );
};
export default ArtworkStatusList;
